import { createReducer } from "redux-create-reducer";

import {
  EXPORT_MULTIPLE_CLIENT_REPORT_PDF,
  CLEAR_MULTIPLE_CLIENTS_REPORT_PDF,
  FORCE_IS_LOADING_FALSE_EXPORT_PDF,
} from "../types";

const initialState = {
  data: new Blob([], { type: "application/pdf" }),
  isLoading: false,
};

const exportMultipleClientReportPdfReducer = createReducer(initialState, {
  [EXPORT_MULTIPLE_CLIENT_REPORT_PDF.DEFAULT]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [EXPORT_MULTIPLE_CLIENT_REPORT_PDF.PENDING]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [EXPORT_MULTIPLE_CLIENT_REPORT_PDF.REJECTED]: (state) => ({
    ...state,
    isLoading: false,
  }),
  [EXPORT_MULTIPLE_CLIENT_REPORT_PDF.FULFILLED]: (state, { payload }) => ({
    ...state,
    data: new Blob([payload.data], { type: "application/pdf" }),
    isLoading: false,
  }),
  [CLEAR_MULTIPLE_CLIENTS_REPORT_PDF]: () => ({ ...initialState }),
  [FORCE_IS_LOADING_FALSE_EXPORT_PDF]: (state) => {
    return {
      ...state,
      isLoading: false,
    };
  },
});

export default exportMultipleClientReportPdfReducer;



// WEBPACK FOOTER //
// ./src/features/reports/reducers/exportMultipleClientReportPdfReducer.js